import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Icon3D } from "@/components/ui/icon-3d";
import { Logo } from "@/components/ui/logo";
import { NAV_ITEMS } from "@/lib/constants";
import { useState } from "react";
import { cn } from "@/lib/utils";

interface TopNavProps {
  variant?: "public" | "auth";
}

export function TopNav({ variant = "public" }: TopNavProps) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border/50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <nav className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6">
        <Logo size="md" showText={true} />

        {variant === "public" && (
          <>
            {/* Desktop nav */}
            <div className="hidden items-center gap-8 lg:flex">
              {NAV_ITEMS.public.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className={cn(
                    "text-sm font-medium transition-colors",
                    location.pathname === item.href
                      ? "text-foreground"
                      : "text-muted-foreground hover:text-foreground"
                  )}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            <div className="hidden items-center gap-4 lg:flex">
              <Button variant="ghost" asChild>
                <Link to="/login">Sign in</Link>
              </Button>
              <Button asChild>
                <Link to="/register">Get started</Link>
              </Button>
            </div>

            {/* Mobile menu button */}
            <Button
              variant="ghost"
              size="icon"
              className="lg:hidden"
              aria-label={mobileOpen ? "Close menu" : "Open menu"}
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <Icon3D name={mobileOpen ? "x" : "menu"} size="sm" />
            </Button>
          </>
        )}

        {variant === "auth" && (
          <Button variant="ghost" asChild>
            <Link to="/">Back to home</Link>
          </Button>
        )}
      </nav>

      {/* Mobile menu */}
      {variant === "public" && mobileOpen && (
        <div className="border-t border-border bg-background px-6 py-6 lg:hidden">
          <div className="flex flex-col gap-4">
            {NAV_ITEMS.public.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={() => setMobileOpen(false)}
                className={cn(
                  "touch-target block text-sm font-medium transition-colors",
                  location.pathname === item.href
                    ? "text-foreground"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-4 flex flex-col gap-3 border-t border-border pt-6">
              <Button variant="ghost" asChild className="justify-start">
                <Link to="/login">Sign in</Link>
              </Button>
              <Button asChild>
                <Link to="/register">Get started</Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}